( function ( $ ) {

  const $search = $( 'section.hero-banner + div.jobsearch' );
  if ( ! $search.length ) { return; }
  
  function resize () {
    const root = document.querySelector( ':root' );
    root.style.setProperty( '--jobsearch-height', `${ $search.outerHeight() }px` );
  }

  const ro = new ResizeObserver( resize );
  ro.observe( $search.get(0) );

})( jQuery );